import { render, staticRenderFns } from "./VoucherStatistic.vue?vue&type=template&id=4df5b342&scoped=true&"
import script from "./VoucherStatistic.vue?vue&type=script&lang=js&"
export * from "./VoucherStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5b342",
  null
  
)

export default component.exports